import { useState, Fragment } from "react";
import "./MissionVision.scss";
import { motion } from "framer-motion";
import { baseUrl } from "../../../utils/apiData";
import Accordion from "react-bootstrap/Accordion";
import { TfiAngleDown } from "react-icons/tfi";

const MissionVision = ({ data }) => {
  const dataList = [
    {
      id: 0,
      title: data?.beatutifull_people_title,
      des: data?.beatutifull_people_description,
    },
    {
      id: 1,
      title: data?.guided_title,
      des: data?.guided_description,
    },
    {
      id: 2,
      title: data?.therapeutic_title,
      des: data?.therapeutic_description,
    },
    {
      id: 3,
      title: data?.endtomind_title,
      des: data?.endtomind_description,
    },
  ];

  const [view, setView] = useState(0);
  const [p, setP] = useState(dataList[0]?.des)
  return (
    <section className="mission_vision p_t p_b">
      <div className="content_wrap">
        {/*For Size > $tab */}
        <div className="desktop_view">
          <div className="tab_wrap p_b">
            {dataList?.map((data, k) => {
              return (
                <button
                  type="button"
                  className={view === k ? "active" : ""}
                  onClick={() => {setView(k); setP(data?.des)}}
                  key={data?.id}
                >
                  {data?.title}
                </button>
              );
            })}
          </div>
          <div className="preview_sec">
              <p>{p}</p>
          </div>
          
        </div>

        {/*For Size <= $tab */}
        <div className="tab_view">
          <Accordion defaultActiveKey="0">
            {dataList?.map((item, k) => {
              return (
                <Accordion.Item eventKey={`${k}`} key={k}>
                  <Accordion.Header>
                    <h4>{item?.title}</h4>
                    <TfiAngleDown />
                  </Accordion.Header>
                  <Accordion.Body>
                    <p>{item?.des}</p>
                  </Accordion.Body>
                </Accordion.Item>
              );
            })}
          </Accordion>
        </div>
      </div>
    </section>
  );
};

export default MissionVision;
